import { generatePath } from 'react-router-dom';

export type Paths = {
  [pattern: string]: {
    pattern: string;
    generate: (params?: { [param: string]: unknown }) => string;
  };
};

export const DEFAULT_LANG_PARAM_NAME = ':lang';

export function createPaths(
  paths: { [path: string | symbol]: string } = {},
  languageParamName: string = `${DEFAULT_LANG_PARAM_NAME}?`,
) {
  return new Proxy<any>(paths, {
    get(target, key: keyof typeof paths) {
      const pattern = `/${languageParamName}${target[key]}`;

      return {
        pattern,
        generate(params: any): string {
          return generatePath(pattern, params);
        },
      };
    },
  }) as Paths;
}

export function createLanguagePathname(currentLang: string, lang: string, publicUrl: string = '/'): string {
  const rx = new RegExp(`^${publicUrl}/${currentLang}`);
  let goto;

  if (rx.test(window.location.pathname)) {
    goto = generatePath(window.location.pathname.replace(currentLang, lang));
  } else {
    goto = `${publicUrl}/${lang}`;
  }

  return goto;
}
